import { Component, EventEmitter, Input, Output } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { ToastrService } from 'ngx-toastr';
import { LoadingService } from 'src/app/services/loading.service';
import { TrainingService } from 'src/app/services/training.service';

@Component({
  selector: 'app-share-idd-number-modal',
  standalone: false,
  templateUrl: './share-idd-number-modal.component.html',
  styleUrl: './share-idd-number-modal.component.scss',
})
export class ShareIddNumberModalComponent {
  @Input() trainingId!: string;

  @Input() showModal = false;
  @Output() showModalChange = new EventEmitter<boolean>();

  constructor(
    private trainingService: TrainingService,
    private loadingService: LoadingService,
    private toastrService: ToastrService,
    private translateService: TranslateService,
  ) {}

  shareIddNumber() {
    this.loadingService.load(
      this.trainingService.setBrokerIddNumber(this.trainingId)
    ).subscribe(() => {
      this.toastrService.success(
        this.translateService.instant('MY-TRAININGS.SHARE-IDD-NUMBER.IDD-SHARED-SUCCESSFULLY')
      );

      this.close();
    });
  }

  close() {
    this.showModal = false;
    this.showModalChange.emit(this.showModal);
  }
}
